const user_info = {
  "main": {
    "name": "Rushyendra Guntupalli",
    "role": "Software Developer",
    "description": "I am a proactive software developer specializing in web development, Java programming, and API development. I contribute to creative projects within dynamic and collaborative teams.",
    "photo": "https://avatars.githubusercontent.com/u/74148058?v=4",
    "email": "rushyendra.7004@gmail.com"
  },
  "socials": {
    "github": "https://github.com/dog-broad",
    "linkedin": "https://www.linkedin.com/in/rushyendra-guntupalli-6a39252b3/",
    "discord": "https://discordapp.com/users/_rushi__"
  },
  "about": "I am a dedicated software developer with a strong interest in using Java, Python, Django, and web development technologies to create impactful projects. My focus is on delivering solutions that enhance user experiences and optimize workflows effectively.",
  "experience": [
    {
      "position": "Programmer Analyst Trainee",
      "company": "Cognizant Technology Solutions",
      "duration": "Apr. 2025 – Present",
      "image": "https://1000logos.net/wp-content/uploads/2021/09/Cognizant-Logo.png",
      "descriptions": [
        "Undergoing training in full-stack development using Microsoft technologies: C#, ASP.NET, HTML, CSS, JavaScript, SQL Server.",
        "Exposure to modern frameworks like SharePoint, Angular, and React in practical lab sessions and project simulations.",
        "Collaborating with peers on team-based projects to apply concepts in web development and backend integration."
      ]
    },
    {
      "position": "Technology Intern",
      "company": "Travel Lykke Pvt. Ltd.",
      "duration": "Oct. 2024 – Feb. 2025",
      "image": "",
      "descriptions": [
        "Built a Django-based travel booking app integrating third-party flight & hotel APIs to enhance real-time booking features.",
        "Improved API performance and user experience through backend optimization and collaborative debugging."
      ]
    },
    {
      "position": "Software Development Engineer Intern",
      "company": "Pyramid IT Learnings",
      "duration": "Jul. 2024 – Sep. 2024",
      "image": "",
      "descriptions": [
        "Developed “Pyramid Ranker”, a platform tracking CP performance across multiple platforms for 2,200+ students using React.js and REST APIs.",
        "Deployed Moodle LMS on DigitalOcean to support online assessments (pyramidexam.in).",
        "Set up a Jobe server on a Dell PowerEdge 630 using Ubuntu, enabling automated test evaluations."
      ]
    },
    {
      "position": "Full-Stack Developer Intern",
      "company": "Swecha, Hyderabad",
      "duration": "May 2022 - June 2022",
      "image": "https://i.ytimg.com/vi/vB6GLt0_mKs/hq720_live.jpg",
      "descriptions": [
        "Completed a four-week civic dashboard internship, becoming proficient in full-stack development.",
        "Gained skills in web scraping, web design, and created user-friendly web applications."
      ]
    }
  ],
  "education": [
    {
      "school": "CMR Institute of Technology, Hyderabad",
      "degree": "B.Tech. - CSE - Data Science",
      "duration": "2021 - 2025",
      "image": "https://i.imgur.com/hECs5NL.png",
      "cgpa": "8.32 / 10"
    },
    {
      "school": "Narayana Junior College",
      "degree": "12th Grade - MPC",
      "duration": "2019 - 2021",
      "image": "https://d2q79iu7y748jz.cloudfront.net/s/_squarelogo/256x256/b0ec704a3bd57a66d2ce0c98e1d35e1a",
      "percentage": "91.20 / 100"
    },
    {
      "school": "Narayana Concept School",
      "degree": "10th Grade - SSC",
      "duration": "2018",
      "image": "https://d2q79iu7y748jz.cloudfront.net/s/_squarelogo/256x256/b0ec704a3bd57a66d2ce0c98e1d35e1a",
      "percentage": "98 / 100"
    }
  ],
  "projects": [
    {
      "title": "Virtual Keyboard App",
      "description": "A mobile-to-PC text transmission app that allows users to type on their PC using their Android device via a TCP connection.",
      "technologies": "Android (Java), Python, TCP",
      "image": "https://i.imgur.com/08uK8CG.png",
      "link": "https://dog-broad.github.io/Virtual-Keyboard-App/",
      "github": "https://github.com/dog-broad/VirtualKeyboardApp"
    },
    {
      "title": "CodeProfileValidator",
      "description": "Web application that checks coding profiles across competitive programming platforms using Django REST API.",
      "technologies": "Django, RESTful API, Python",
      "image": "https://blueshelltech.com/media/2021/05/python-django-1024x576.jpg",
      "link": "https://codeprofilevalidator.onrender.com/",
      "github": "https://github.com/dog-broad/CodeProfileValidator"
    },
    {
      "title": "CMRIT2025Leaderboard",
      "description": "Automated platform to track coding performance of CMRIT students using web scraping and interface design.",
      "technologies": "Java, Python, SQLite, HTML/CSS/JavaScript",
      "image": "https://i.imgur.com/jFxwqe1.png",
      "link": "https://gabyah92.github.io/CMRIT2025Leaderboard/",
      "github": "https://github.com/gabyah92/CMRIT2025Leaderboard"
    },
    {
      "title": "Morse Code Translator",
      "description": "Java GUI-based translator for English–Morse and vice versa with features like file I/O and theme support.",
      "technologies": "Java, Maven, Swing, FlatDarkLaf",
      "image": "https://i.imgur.com/t6NBT3f.png",
      "link": "https://github.com/dog-broad/MorseCodeTranslator",
      "github": "https://github.com/dog-broad/MorseCodeTranslator"
    },
    {
      "title": "Rain Bucket Game",
      "description": "Arcade-style game using Python and AI logic to control a bucket catching raindrops, built with Pygame.",
      "technologies": "Python, Pygame, Artificial Intelligence",
      "image": "https://i.imgur.com/LXkBYu2.png",
      "link": "https://github.com/dog-broad/RainDropGameAI",
      "github": "https://github.com/dog-broad/RainDropGameAI"
    },
    {
      "title": "Currency Converter App",
      "description": "Swing-based GUI app in Java for real-time currency conversion with API integration and modern UI.",
      "technologies": "Java, Swing, API Integration",
      "image": "https://i.imgur.com/WgwCFL2.png",
      "link": "https://github.com/dog-broad/CurrencyConverterApp",
      "github": "https://github.com/dog-broad/CurrencyConverterApp"
    }
  ],
  "certificates": [
    {
      "title": "C Programming for Beginners",
      "description": "Provided by Udemy",
      "icon": "udemy",
      "link": "https://www.udemy.com/certificate/UC-7243834b-07ad-48aa-9188-79a118d20540/"
    },
    {
      "title": "Advanced C Programming Course",
      "description": "Provided by Udemy",
      "icon": "udemy",
      "link": "https://www.udemy.com/certificate/UC-ecae58a5-18d1-4284-9d92-64443b0938f3/"
    }
  ],
  "contact": {
    "description": "Feel free to reach out to me on any of my social media platforms or via email."
  },
  "skills": [
    "Web development",
    "Java programming",
    "API development",
    "Django",
    "Python",
    "React.js",
    "Full-stack development",
    "RESTful APIs",
    "Git",
    "Problem solving",
    "Collaboration",
    "Communication",
    "Docker",
    "C#",
    "ASP.NET",
    "HTML",
    "CSS",
    "JavaScript",
    "SQL Server",
    "SharePoint",
    "Angular"
  ]
};

export default user_info;
